import OrderService from '@/services/pdv-balcao/OrderService'

let order = {
  empresa: { CODIGO: '', NOME: '' },
  vendedor: { CODIGO: '', NOME: '' },
  departamento: { CODIGO: '' },
  moeda: 0, // inicia com moeda 0 (principal)
  condicaoPgto: undefined,
  geradoPelaRotina: undefined, // definido no preOrder do Index.vue PDV Balcao usando state.orderType
  tipoPreco: 'PRECOVAREJO',
  subTotal: 0,
  total: 0,
  desconto: 0,
  sequencial: 0,
  filial: 1,
  data: '',
  previsaoEntrega: '',
  tipoPrevisaoEntrega: undefined,
  liberado: 'W',
  //SETAR LIBERADO = W de WEB para que fique invisível no gestão
}

export const orderModule = {
  namespaced: true,
  strict: process.env.NODE_ENV !== 'production',
  state: {
    loadingItems: false,
    orderList: [],
    order: order,
    orderType: {
      web: 'Balcao_web',
      guest: 'Balcao_guest',
    },
  },
  mutations: {
    SET_ORDER(state, payload) {
      state.order = {}
      let newOrder = { ...order, ...payload }
      if (payload.sequencial) {
        newOrder.sequencial = parseInt(payload.sequencial)
      }
      state.order = newOrder
    },
    SET_ORDER_ATTRIBUTES(state, payload) {
      if (payload.sequencial) state.order.sequencial = payload.sequencial
      if (payload.numero) state.order.numero = payload.numero
    },
    RESET_ORDER(state) {
      state.order = order
    },
    SET_ORDERS_LIST(state, payload) {
      state.orderList = payload
    },
    SET_LOADING(state) {
      state.loadingItems = !state.loadingItems
    },
  },
  actions: {
    async newOrder({ commit }, payload) {
      let service = new OrderService()
      let response = await service.insertOrder(payload)
      commit(
        'SET_ORDER_ATTRIBUTES',
        service.translateFromFirebird(response.data)
      )
      return response.status
    },

    async setOrder({ commit }, payload) {
      await commit('SET_ORDER', payload)
    },

    async loadOrder({ dispatch }, payload) {
      let service = new OrderService()
      let response = await service.loadOrder(payload)
      dispatch('setOrder', service.translateFromFirebird(response))
      return `${response.NUMERO}`
    },

    async updateOrder({ commit }, payload) {
      let service = new OrderService()
      let response = await service.updateOrder(payload)
      commit('SET_ORDER', payload)
      return response.status
    },

    async getOrders({ commit }, payload) {
      try {
        await commit('SET_LOADING', payload)

        let service = new OrderService()
        let response = await service.getOrders(payload)

        commit('SET_ORDERS_LIST', response)
      } finally {
        await commit('SET_LOADING', payload)
      }
    },

    resetOrder({ commit }) {
      commit('RESET_ORDER')
    },

    async deleteOrder({ commit, dispatch }, payload) {
      let service = new OrderService()

      await dispatch(
        'pdvBalcaoModule/orderItensModule/removeAllOrderItens',
        {},
        { root: true }
      )
      await service.delete(payload.sequencial)
      commit('RESET_ORDER')
    },
  },
  getters: {
    getOrdersList: (state) => {
      return state.orderList
    },
    getOrderType: (state) => {
      return state.orderType
    },
  },
}
